import httpService from './HttpService';

export default class BaseAPIService {
  constructor() {
    this.api = httpService;
    this.apiClient = this.api.client;
  }
}
